import layoutPatient from "../pages/module-patient/layout/index-patient";

export default [
    {
        path: "/patients",
        component: layoutPatient,
        children: [{
            path: "create",
            name: "create",
            component: () =>
                import("@/pages/module-patient/patients/create"),
        },],
    },

    {
        path: "/patients",
        component: layoutPatient,
        children: [{
            path: "list",
            name: "list",
            component: () =>
                import("@/pages/module-patient/patients/index"),
        },],
    },

    {
        path: "/patients",
        component: layoutPatient,
        children: [{
            // path: "update/:id(\\d+)",
            path: "detail/:uuid",
            name: "detail",
            component: () =>
                import("@/pages/module-patient/patients/detail"),
            props: true,
        },],
    },

    {
        path: "/patients",
        component: layoutPatient,
        children: [{
            // path: "update/:id(\\d+)",
            path: "update/:uuid",
            name: "update",
            component: () =>
                import("@/pages/module-patient/patients/update"),
            props: true,
        },],
    },




]
